/*
 * Created by: cparaschiv
 * Date: 09.10.2013, 15:57
 */


(function () {
    var foreachBinding = ko.bindingHandlers['foreach'];

    function replaceAttrWithBinding(el, attributeNames, funcName) {
        var attributeName,
            val,
            bindingStr,
            bindings = [],
            i;

        el = $(el);

        for (i = 0; i < attributeNames.length; i++) {
            attributeName = attributeNames[i];
            val = el.attr(attributeName);
            if (typeof val == 'undefined' || val === false)
                continue;

            // assert attribute does not contain comma...
            bindings.push('\'' + attributeName + '\'' + ': ' + funcName + '("' + val + '")');
            el.removeAttr(attributeName);
        }

        if (bindings.length === 0)
            return;

        bindingStr = el.attr('data-bind');

        if (bindingStr) {
            if (bindingStr.replace(/[ '"]/g, '').indexOf('attr:{') !== -1) {
                var bindingList = bindingStr.split('attr:{');
                bindingList[1] = bindings.join(', ') + ', ' + bindingList[1];
                bindingStr = bindingList.join('attr:{');
            } else
                bindingStr += ', attr: {' + bindings.join(', ') + '}';
        } else {
            bindingStr = ' attr: {' + bindings.join(', ') + '}';
        }

        el.attr('data-bind', bindingStr);
    }

    /**
     * @class TS.domain.RepeaterEditDomain
     * @extends TS.domain.EditDomain
     * @classdesc View model for repeater elements. Since its derived from an {@link TS.domain.EditDomain edit model}
     * it inherits all its properties and behavior.
     * However, the 'Record' and 'Navigation' command categories are not present.
     */
    TS.domain.RepeaterEditDomain = new Class(
    /** @lends TS.domain.RepeaterEditDomain# */
    {
        Extends: TS.domain.EditDomain,
        _beforeBind: $.noop,
        _hookDocument: $.noop,

        initialize: function (config) {
            if (config.CommandCategories) {
                if (config.CommandCategories.Navigation) {
                    delete config.CommandCategories.Navigation;
                }
                if (config.CommandCategories.Record) {
                    delete config.CommandCategories.Record;
                }
            }
            this.parent(config);
        },

        // CP 20140204 - repeater models should not set window title
        _setWindowTitle: $.noop,

        getElementId: function (id) {
            var me = this,
                repeaterProp = me[TS.Constants.repeaterProp],
                index = repeaterProp.Domains().indexOf(me),
                splitter = '_',
                idParts = id.split(splitter),
                lastIdPart,
                res;

            if (idParts.length > 1) {
                lastIdPart = idParts.pop();
                res = idParts.join(splitter) + splitter + index + splitter + lastIdPart;
            } else {
                res = id + '_' + index;
            }
            return res;
        }
    });

    ko.bindingHandlers['repeaterForeach'] = {
        'init': function (element, valueAccessor, allBindings, domain, bindingContext) {
            var attributes = ['id', 'for', 'data-for'],
                attributesSelector = '[' + attributes.join('],[') + ']',
                repeater = TS.unwrap(valueAccessor()),
                bindableElements = $(element).find(attributesSelector);

            bindableElements.each(function (i, el) {
                replaceAttrWithBinding(el, attributes, 'getElementId');
            });

            return foreachBinding['init'](element, repeater.Domains, allBindings, domain, bindingContext);
        },
        'update': function (element, valueAccessor, allBindings, domain, bindingContext) {
            var repeater = TS.unwrap(valueAccessor());
            return foreachBinding['update'](element, repeater.Domains, allBindings, domain, bindingContext);
        }
    };

})();